import React from "react";
import { ShieldCheck, CalendarHeart, Phone, Check } from "lucide-react";
import { TexasStarPlusEmblem } from "./InsuranceSection";

const HeroSection = () => {
  return (
    <section id="top" className="hero-bg relative overflow-hidden" data-testid="hero-section">
      <div className="container-hc pt-12 pb-20 md:pt-20 md:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left content */}
          <div className="lg:col-span-7">
            <div
              className="hc-chip"
              data-testid="hero-medicare-badge"
              style={{
                background: "rgba(217, 45, 58, 0.10)",
                color: "#d92d3a",
                border: "1px solid rgba(217, 45, 58, 0.30)",
              }}
            >
              <ShieldCheck size={14} />
              We Accept Medicaid / STAR+PLUS
            </div>

            <h1
              className="font-serif-display mt-7 text-[44px] sm:text-6xl lg:text-[78px] leading-[1.02] tracking-tight text-[color:var(--hc-navy)]"
              data-testid="hero-headline"
            >
              Where our home is{" "}
              <span className="italic text-[color:var(--hc-coral)]">your home.</span>
            </h1>

            <p className="mt-7 max-w-xl text-lg md:text-xl text-[color:var(--hc-navy)]/75 leading-relaxed">
              Hillcrest Assisted Living is a welcoming community in the heart of San Augustine,
              Texas — dedicated to providing compassionate care, comfort, and independence for
              adults who need a little extra support in their daily lives.
            </p>

            <p className="mt-5 max-w-xl text-lg md:text-xl text-[color:var(--hc-navy)]/85 leading-relaxed">
              <span className="font-semibold text-[color:var(--hc-navy)]">
                Proudly accepting Medicaid STAR+PLUS
              </span>{" "}
              — making quality assisted living accessible for the families who need it most.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a href="#tour" className="btn-coral justify-center" data-testid="hero-schedule-tour">
                <CalendarHeart size={18} />
                Take a Virtual Tour
              </a>
              <a
                href="tel:9362750222"
                className="btn-outline-navy justify-center"
                data-testid="hero-call"
              >
                <Phone size={18} />
                Call (936) 275-0222
              </a>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3 max-w-lg">
              {["Medicaid / STAR+PLUS", "Family-Focused", "24/7 Care Staff"].map((label) => (
                <div
                  key={label}
                  className="flex items-center gap-2 text-[15px] text-[color:var(--hc-navy)]/80"
                  data-testid={`trust-badge-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <span className="flex items-center justify-center w-5 h-5 rounded-full border-2 border-[color:var(--hc-green)]">
                    <Check size={11} className="text-[color:var(--hc-green)]" strokeWidth={3} />
                  </span>
                  {label}
                </div>
              ))}
            </div>
          </div>

          {/* Right side: House photo + Texas STAR+PLUS emblem (clean business-card style) */}
          <div className="lg:col-span-5 relative flex flex-col items-center" data-testid="hero-card-wrap">
            <div className="relative w-full bg-white rounded-[28px] shadow-2xl border-[3px] border-white p-5 md:p-6 flex flex-col items-center gap-5">
              <div className="w-full rounded-[20px] overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/s3kge7y7_IMG_0309.jpeg"
                  alt="Hillcrest Assisted Living — front entrance"
                  className="block w-full h-[300px] md:h-[340px] object-cover"
                  data-testid="hero-house-image"
                />
              </div>

              <TexasStarPlusEmblem />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
